import { render, staticRenderFns } from "./onlyYiLianInfo.vue?vue&type=template&id=12d1d217&scoped=true"
import script from "./onlyYiLianInfo.vue?vue&type=script&lang=js"
export * from "./onlyYiLianInfo.vue?vue&type=script&lang=js"
import style0 from "./onlyYiLianInfo.vue?vue&type=style&index=0&id=12d1d217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1d217",
  null
  
)

export default component.exports